module.exports = __webpack_public_path__ + "img/htit2.f22a7675.png";